import React from 'react';

import { formatDuration, msUntil, msToDays } from 'common/utils/time';

export interface ProductInfoBonusExpirationProps {
    expiration?: string | null;
    showQuantity?: boolean;
}

export const ProductInfoBonusExpiration = ({
    expiration,
    showQuantity,
}: ProductInfoBonusExpirationProps) => {
    if (!expiration) {
        return null;
    }

    const timeRemaining = msUntil(expiration);

    if (msToDays(timeRemaining) > 7) {
        return null;
    }

    return (
        <div className="text-brand-accent flex flex-col sm:justify-center justify-end pl-1 sm:pb-0 pb-1.5">
            <span className={`text-xs font-semibold ${showQuantity ? 'pt-2' : 'pt-0 pb-1'}`}>
                {formatDuration(timeRemaining)} left
            </span>
        </div>
    );
};

export const AffiliateBonusExpiration = ({ expiration }: { expiration: string }) => {
    if (!expiration) {
        return null;
    }

    const timeRemaining = msUntil(expiration);

    if (msToDays(timeRemaining) > 7) {
        return null;
    }

    return (
        <span className="sm:pt-0 pt-1 sm:text-right text-center font-semibold sm:mr-3 text-xs text-bonus-pink flex-wrap">
            {formatDuration(timeRemaining)} left
        </span>
    );
};
